import $store from 'src/store'

export default {
  namespaced: true,
  state: {
    colors: [],
    competitorsColors: JSON.parse(localStorage.getItem('competitorsColors')) || {},
  },
  mutations: {
    SET_COLORS(state, payload) {
      state.colors = payload
    },
    ADD_COMPETITOR_COLOR(state, { name, color }) {
      const newObj = JSON.parse(localStorage.getItem('competitorsColors')) || {
        ...state.competitorsColors,
      }

      newObj[$store.state.settings.dealerShipId] = newObj[$store.state.settings.dealerShipId] || {}
      newObj[$store.state.settings.dealerShipId][name] = color
      state.competitorsColors = newObj
      localStorage.setItem('competitorsColors', JSON.stringify(state.competitorsColors))
    },
  },
  getters: {
    getCompetitorColor: (state) => (name) =>
      state.competitorsColors[$store.state.settings.dealerShipId]?.[name],
  },
  actions: {
    setCompetitorColor({ commit, state }, name) {
      const usedColors = Object.values(
        state.competitorsColors[$store.state.settings.dealerShipId] || {}
      )

      for (let i = 0; i < state.colors.length; i++) {
        if (!usedColors.includes(state.colors[i])) {
          commit('ADD_COMPETITOR_COLOR', {
            name,
            color: state.colors[i],
          })

          return state.colors[i]
        }
      }
    },
  },
}
